import { render } from "./ChodanCoinList.vue?vue&type=template&id=74257058&scoped=true"
import script from "./ChodanCoinList.vue?vue&type=script&lang=js"
export * from "./ChodanCoinList.vue?vue&type=script&lang=js"

import "./ChodanCoinList.vue?vue&type=style&index=0&id=74257058&lang=scss&scoped=true"

import exportComponent from "/home/hulk-suman/Music/Insidejob-admin-devlopment-1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74257058"]])

export default __exports__